import { getCompanyContracts } from '@/managers/contracts/useCases/getCompanyContracts';
import { createCompanyContract } from '@/managers/contracts/useCases/createCompanyContract';
import { removeCompanyContract } from '@/managers/contracts/useCases/removeCompanyContract';

export default {
  getCompanyContracts,
  createCompanyContract,
  removeCompanyContract,
};
